import { render, staticRenderFns } from "./auth-base.vue?vue&type=template&id=47969d3b&scoped=true&"
import script from "./auth-base.vue?vue&type=script&lang=ts&"
export * from "./auth-base.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base.vue?vue&type=style&index=0&id=47969d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47969d3b",
  null
  
)

export default component.exports